/* unplugin-vue-components disabled */import { render } from "./BaseNavbar.vue?vue&type=template&id=2325af7e&scoped=true"
const script = {}

import "./BaseNavbar.vue?vue&type=style&index=0&id=2325af7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2325af7e"]])

export default __exports__